import { BankDetailsWithConfig } from "@/components/BankDetails";
import { Button } from "@/components/ui/Button";
import classes from "./Form.module.scss";
import { useImperativeHandle, useRef, useState, type Ref } from "react";
import { ImperativeHandle } from "@/types/Form";
import { dispatchEvent } from "@/utils/event-dispacher";
import { EventName } from "@/types/Events";
import { DetailsStep } from "@/types/Navigation";
import { useDonationFormStore } from "@/stores";
import { TurnstileWidget } from "@/components/TurnstileWidget";
import { useTurnstile } from "@/hooks/useTurnstile";
import { DonationAmountConfirmation } from "./DonationAmountConfirmation";

type FormStepBankDetailsProps = {
  onStepSubmit: () => void;
  ref?: Ref<ImperativeHandle>;
};

export function FormStepBankDetails(props: FormStepBankDetailsProps) {
  const { onStepSubmit, ref } = props;

  const bankDetailsRef = useRef<ImperativeHandle>(null);
  const [processing, setProcessing] = useState(false);
  const { bankDetails } = useDonationFormStore();
  const { isReady } = useTurnstile();

  useImperativeHandle(ref, () => ({
    validate: async () => {
      if (!bankDetailsRef.current) {
        return {
          isValid: true,
        };
      }

      return bankDetailsRef.current.validate();
    },
  }));

  const handleSubmit = async () => {
    setProcessing(true);
    const validation = await bankDetailsRef.current?.validate();
    setProcessing(false);
    if (validation?.isValid) {
      onStepSubmit();
      dispatchEvent(EventName.STEP_SUBMIT, {
        step_name: DetailsStep.BankDetails,
        data: bankDetails,
      });
    }
  };

  return (
    <div>
      <BankDetailsWithConfig ref={bankDetailsRef} />

      <DonationAmountConfirmation />
      <TurnstileWidget />

      <div className={classes.pagination}>
        <Button
          size="large"
          isBusy={processing || !isReady}
          onClick={handleSubmit}
        >
          Complete donation
        </Button>
      </div>
    </div>
  );
}
